const state = {
  templateList: [],
  pathwaysList: [],
  industryList: []
};
export default state;
